<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card v-if="item">
            <v-toolbar flat color="#008dd4" dark>
                <v-btn icon @click="$parent.billing_dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Facturación: {{ item.partnership.pagename }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-container fluid>
                    <v-row>
                        <v-col lg="3">
                            <v-card>
                                <v-list two-line subheader>
                                    <v-list-item>
                                        <v-list-item-avatar>
                                            <v-icon color="#008dd4" x-large>mdi-currency-usd</v-icon>
                                        </v-list-item-avatar>

                                        <v-list-item-content>
                                            <v-list-item-title><strong>Pago total mensual</strong></v-list-item-title>
                                            <v-list-item-subtitle class="text-h4">{{ total }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                                <v-card-actions>
                                    <v-btn text block>Realizar pago</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>

                        <v-col lg="9">
                            <v-card>
                                <v-data-table
                                    :headers="headers"
                                    :items="item.referreds"
                                    :loading="loading"
                                    :footer-props="footer_props"
                                    :loading-text="loading_text"
                                    :no-data-text="no_data_text"
                                    :no-results-text="no_result_text"
                                    :search="search"
                                >

                                </v-data-table>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props:['dialog','item'],
    data: () => ({
        //data table props
        color:"#818181",
        search:"",
        loading:false,
        loading_text:"Cargando...",
        no_data_text:"Sin elementos registrados",
        no_result_text:"Sin coincidencias",
        headers:[
            { text:'Nombre(s)', value:'referred.fullname' },
            { text:'Correo electrónico', value:'referred.email' },
        ],
        footer_props:{
            itemsPerPageText:"Filas por página",
            showCurrentPage:true,
            itemsPerPageAllText:"Todo"
        },
    }),

    computed:{
        total:function()
        {
            return this.item.partnership.agreement * this.item.referreds.length;
        }
    }
}
</script>